import { CoreTheme } from '@kite-js/theme'
import { enterpriseTheme } from '@kite-js/theme-enterprise'

const agodaTheme: CoreTheme = {
    ...enterpriseTheme,
    button: {
        ...enterpriseTheme.button,
        M: {
            ...enterpriseTheme.button.M,
            pX: 'XL',
        },
    },
}

export default agodaTheme
